import React, {Suspense} from 'react'

interface SuspensePopupProps {
  fallback: JSX.Element
  children: (props: {[key: string]: any}) => JSX.Element
  [key: string]: any
}

export function SuspensePopup({
  fallback,
  children,
  ...popupProps
}: SuspensePopupProps): JSX.Element {
  return <Suspense fallback={fallback}>{children(popupProps)}</Suspense>
}
